import { render, staticRenderFns } from "./BCOptionalFeaturesGPS.vue?vue&type=template&id=cffdddca"
import script from "./BCOptionalFeaturesGPS.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesGPS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports